import { songGuideRows, songInfo, songSteps } from "@/mocks/festival";

export default function SongGuide() {
  return (
    <section className="w-full bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <div className="reveal mb-10 md:mb-14">
          <span className="text-xs tracking-[0.24em] text-primary-600">HOW TO ENTER</span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl leading-tight text-foreground-950">
            참가 전 확인해 주세요
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <div className="reveal">
            <div className="w-full aspect-[4/3] overflow-hidden rounded-lg">
              <img
                src={songInfo.image.src}
                alt={songInfo.image.alt}
                width={1100}
                height={780}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {songSteps.map((step, i) => (
                <div
                  key={step.no}
                  className={`reveal reveal-delay-${i + 1} rounded-lg border border-background-200 bg-background-100 px-5 py-5`}
                >
                  <span className="font-heading text-xl text-accent-600">{step.no}</span>
                  <strong className="mt-2 block text-sm text-foreground-950">{step.title}</strong>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="reveal reveal-delay-2 rounded-lg bg-primary-50 border border-primary-100 p-6 md:p-8">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-white text-xl">
                <i className="ri-mic-line"></i>
              </span>
              <div>
                <strong className="block font-heading text-lg text-foreground-950">{songInfo.name}</strong>
                <span className="text-xs text-foreground-600">대회 안내</span>
              </div>
            </div>

            <dl className="mt-6 flex flex-col">
              {songGuideRows.map((row) => (
                <div
                  key={row.label}
                  className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4 border-t border-primary-100 py-3.5 first:border-t-0 sm:first:border-t"
                >
                  <dt className="w-full sm:w-28 shrink-0 text-xs tracking-[0.12em] text-primary-700 pt-0.5">
                    {row.label}
                  </dt>
                  <dd className="text-sm leading-relaxed text-foreground-800">{row.value}</dd>
                </div>
              ))}
            </dl>

            <p className="mt-6 rounded-lg bg-accent-50 border border-accent-200/70 px-4 py-3 text-xs leading-relaxed text-accent-900">
              반주 음원(USB 또는 유튜브 링크)을 준비해 주세요. 곡명과 참가 인원을 신청서에 정확히 기재해 주시면
              접수가 원활합니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}